import * as S from './styled'

const SeparatingEdge = () => <S.DividingLine />

export default SeparatingEdge
